// error-logging.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorLoggingInterceptor implements HttpInterceptor {
  urlKeyWordsForLogging = ['browsermodules', 'features'];

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          !this.urlKeyWordsForLogging.some((keyword) =>
            req.url.includes(keyword)
          )
        ) {
          return throwError(error);
        }

        const errorMessage = this.getErrorBasedOnFailedUrl(req);
        return throwError(error);
      })
    );
  }

  private getErrorBasedOnFailedUrl(req: HttpRequest<any>) {
    let errorMessage = 'An unknown error occurred';
    if (req.url.includes('browsermodules')) {
      errorMessage = 'An error occurred while fetching browser modules.';
    } else if (req.url.includes('features')) {
      errorMessage = 'An error occurred while fetching features.';
    }
    return errorMessage;
  }
}
